import script from "./Contabilidad.vue?vue&type=script&setup=true&lang=js"
export * from "./Contabilidad.vue?vue&type=script&setup=true&lang=js"

import "./Contabilidad.vue?vue&type=style&index=0&id=fe455040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe455040"]])

export default __exports__